import type { Maybe } from '@adornis/base/utilTypes.js';
import { getByID } from '@adornis/baseql/operations/mongo.js';
import type { BaseQLSelectionSet } from '@adornis/baseql/utils/queryGeneration.js';
import { ChancenComponentSemanticEntityMultiPicker } from '@chancenwerk/client/components/semantics/chancen-component-semantic-entity-multi-picker.js';
import { KpfFilter } from '@chancenwerk/db/filter/KpfFilter.js';
import { RoleFilter } from '@chancenwerk/db/filter/RoleFilter.js';
import { ChancenRole } from '@chancenwerk/db/semantics/ChancenRole.js';
import { KPF } from '@chancenwerk/master-data-management/kpf/entities/KPF.js';
import { customElement } from 'lit/decorators.js';
/**
 * @element chancen-component-semantic-predicate-multi-picker
 */
@customElement('chancen-component-semantic-predicate-multi-picker')
export class ChancenComponentSemanticPredicateMultiPicker extends ChancenComponentSemanticEntityMultiPicker<
  ChancenRole,
  KpfFilter
> {
  override placeholder: string = 'Rolle';

  protected override _subscription() {
    return ChancenRole.subscribeRolesPaginatedFiltered;
  }

  protected override _resolveID(ids: string[]): (gqlFields: BaseQLSelectionSet<KPF>) => Promise<Maybe<ChancenRole[]>> {
    return getByID<typeof ChancenRole>(ChancenRole, ids);
  }

  protected override _filter() {
    return RoleFilter;
  }

  protected override _limit() {
    return 100;
  }

  protected override _selectionSet() {
    return {
      _class: 1,
      _id: 1,
      name: 1,
      readableName: 1,
      aliases: 1,
      section: 1,
    };
  }
}
